import { AppVariantConfig } from '@/types/app-config';

export const marketplaceOnlyVariant: AppVariantConfig = {
  id: 'marketplace-only',
  name: 'Marketplace Only',
  description: 'Pure e-commerce focused with marketplace only (no donations)',
  defaultRoute: 'marketplace',
  appModules: {
    home: { enabled: true, requiresFeature: 'home' },
    marketplace: { 
      enabled: true, 
      requiresFeature: 'payments.marketplace',
      checkIfLive: true 
    },
    directory: { enabled: true },
    payments: { 
      enabled: true, 
      requiresFeature: 'payments'
      // No submodules - no donations support
    }
  },
  adminModules: {
    users: { enabled: true },
    payments: { enabled: true },
    settings: { enabled: true },
    design: { enabled: true },
    analytics: { enabled: true }
  }
}; 